import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { GoogleMapsAPIWrapper } from '@agm/core';
import { Marker } from '@agm/core/services/google-maps-types';
import { GmapsPoint } from './gmaps-point.model';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
declare var google: any;

/* tslint:disable:directive-selector */
@Directive({
  selector: 'gmaps-directions'
})
/* tslint:enable */

export class GmapsDirectionsDirective implements OnInit, OnDestroy {
  @Input() color: string = '#FFFFFF';
  public origin: GmapsPoint;
  public destination: GmapsPoint;
  public directionsDisplay: any;
  public travelMode: string = 'drive';
  private marker: Marker;
  private distance: string;
  private time: string;
  private translateSubscription: Subscription = new Subscription();
  private subscription: Subscription = new Subscription();

  constructor(
    private gmapsApi: GoogleMapsAPIWrapper,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getTranslations();

    this.subscription.add(this.translate.onLangChange
      .subscribe(() => {
        this.getTranslations();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.translateSubscription.unsubscribe();
  }

  private getTranslations(): void {
    this.translateSubscription.add(
      this.translate.get('model.gmaps.distance')
        .subscribe((translatedString: string) => {
          this.distance = translatedString;
        })
    );

    this.translateSubscription.add(
      this.translate.get('model.gmaps.time')
        .subscribe((translatedString: string) => {
          this.time = translatedString;
        })
    );
  }

  public updateDirections(additionalText?: string): void {
    this.gmapsApi.getNativeMap().then(map => {

      const directionsService = new google.maps.DirectionsService();

      // Set travel mode
      let travel;

      if (this.travelMode === 'drive') {
        travel = google.maps.DirectionsTravelMode.DRIVING;
      } else if (this.travelMode === 'walk') {
        travel = google.maps.DirectionsTravelMode.WALKING;
      } else if (this.travelMode === 'transit') {
        travel = google.maps.DirectionsTravelMode.TRANSIT;
      } else if (this.travelMode === 'bicycle') {
        travel = google.maps.DirectionsTravelMode.BICYCLING;
      }

      let latLngA;

      if (this.origin) {
        latLngA = new google.maps.LatLng({ lat: this.origin.latitude, lng: this.origin.longitude });
      } else {
        throw new Error('GmapsDirectionsDirective error: origin not set');
      }

      let latLngB;

      if (this.destination) {
        latLngB = new google.maps.LatLng({ lat: this.destination.latitude, lng: this.destination.longitude });
      } else {
        return;
      }

      this.directionsDisplay.setMap(map);

      this.directionsDisplay.setOptions({
        polylineOptions: {
          strokeWeight: 8,
          strokeOpacity: 0.7,
          strokeColor: this.color
        }
      });

      directionsService.route(
        {
          origin: latLngA,
          destination: latLngB,
          avoidHighways: true,
          travelMode: travel
        },
        (response: any, status: any) => {
          if (status === 'OK') {

            this.directionsDisplay.setDirections(response);

            const point = response.routes[0].legs[0];

            // Remove last marker if it exists
            if (this.marker) {
              this.marker.setMap(null);
            }

            // Create new marker at the new destination
            const marker = new google.maps.Marker({
              position: point.end_location,
              map: map
            });

            // Create info window
            const infowindow = new google.maps.InfoWindow({
              content:
                `${this.distance}: ${point.distance.text} ${this.time}: ${point.duration.text}
                  ${additionalText ? additionalText : ''}`
            });

            this.marker = marker;

            // Show info window above marker
            infowindow.open(map, marker);

            // Set a min zoom, so all points are inside view
            // const listener = google.maps.event.addListener(map, 'idle', () => {
            //   if (map.getZoom() > 14)
            //     map.setZoom(14);

            //   google.maps.event.removeListener(listener);
            // });
          }
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/gmaps-directions.directive.ts